import React from 'react';
import { Redirect } from 'react-router-dom';
import { useTenantAuth } from '../../context/tenantAuth';

export const RequireTenantAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isLoggedIn, loading } = useTenantAuth();

  if (loading) return <div>Loading...</div>;

if (!isLoggedIn) return <Redirect to="/tenant/login" />;

  return <>{children}</>;
};
